import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import withReactContent from "sweetalert2-react-content";
import { base_api_url } from "../../../environment.jsx";

const EditTableModal = ({ show, onClose, TableData, onFormSubmit }) => {
    const MySwal = withReactContent(Swal);

    const [loading, setLoading] = useState(false);
    const [prefix, setPrefix] = useState("");
    const [suffix, setSuffix] = useState("");
    const [capacite, setCapacite] = useState(4);
    const [initialSuffix, setInitialSuffix] = useState("");
    const [initialCapacite, setInitialCapacite] = useState(4);

    const showCapacite =
    prefix.toLowerCase() !== "client" &&
    prefix.toLowerCase() !== "VAD";

    useEffect(() => {
        if (TableData) {
             const parts = (TableData.numero_table || "").split("-");

            const currentSuffix = parts.slice(1).join("-");

            setPrefix(parts[0] || "");
            setSuffix(currentSuffix);
            setCapacite(TableData.capacite || 4);

            // Sauvegarde des valeurs d'origine
            setInitialSuffix(currentSuffix);
            setInitialCapacite(TableData.capacite || 4);
        }
    }, [TableData]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const token = JSON.parse(localStorage.getItem("user"))?.access_token;

            await axios.put(
                `${base_api_url}api/tables/${TableData.code_qr}`,
                {
                    numero_table: `${prefix}-${suffix}`,
                    capacite: showCapacite ? capacite : 0,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            MySwal.fire({
                icon: "success",
                text: "Table modifiée avec succès",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000
            });

            onClose();

            if (onFormSubmit) {
                onFormSubmit();
            }

        } catch (error) {
            MySwal.fire({
                icon: "error",
                text:
                    error.response?.data?.error ||
                    "Erreur lors de la modification",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;
    const hasChanges = showCapacite
        ? (
            suffix.trim() !== initialSuffix.trim() ||
            capacite !== initialCapacite
        )
        : (
            suffix.trim() !== initialSuffix.trim()
        );

    return (
        <>
            <div
                onClick={onClose}
                style={{
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0,0,0,0.35)",
                    backdropFilter: "blur(4px)",
                    zIndex: 1040
                }}
            />

            <div
                style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    width: "480px",
                    maxWidth: "94vw",
                    backgroundColor: "#fff",
                    borderRadius: "20px",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
                    zIndex: 1050,
                    overflow: "hidden"
                }}
            >
                <form onSubmit={handleSubmit}>

                    {/* Header */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "28px 28px 20px 28px",
                            borderBottom: "1px solid #f3f4f6"
                        }}
                    >
                        <h5
                            style={{
                                margin: 0,
                                fontSize: "20px",
                                fontWeight: 700
                            }}
                        >
                            Modifier la table
                        </h5>

                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "24px",
                                cursor: "pointer"
                            }}
                        >
                            ×
                        </button>
                    </div>

                    {/* Body */}
                    <div style={{ padding: "24px 28px"}}>

                        {/* Préfixe */}
                        <div style={{ marginBottom: 20 }}>
                            <label className="mb-2">
                                Préfixe
                            </label>

                            <input
                                type="text"
                                value={prefix}
                                readOnly
                                className="form-control"
                                style={{
                                    background: "#f9fafb",
                                    color: "#000",
                                }}
                            />
                        </div>

                        {/* Suffixe */}
                        <div style={{ marginBottom: 20 }}>
                            <label className="mb-2">
                                Nom
                            </label>

                            <input
                                type="text"
                                value={suffix}
                                onChange={(e) => setSuffix(e.target.value)}
                                className="form-control"
                                style={{
                                    color: "#000",
                                }}
                            />
                        </div>

                        {/* Capacité */}
                        {showCapacite && (
                            <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"                            
                                    }}
                            >
                                <label>Capacité</label>

                                <div style={{ display: "flex" }}>

                                    <button
                                        type="button"
                                        onClick={() =>
                                            setCapacite(Math.max(1, capacite - 1))
                                        }
                                        className="btn btn-light"
                                    >
                                        -
                                    </button>

                                    <div
                                        style={{
                                            width: 60,
                                            textAlign: "center",
                                            lineHeight: "38px",
                                            color: "#000",
                                        }}
                                    >
                                        {capacite}
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() =>
                                            setCapacite(capacite + 1)
                                        }
                                        className="btn btn-light"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>

                       )}
                    </div>

                    {/* Footer */}
                    <div
                        style={{
                            padding: "0 28px 28px"
                        }}
                    >
                        <button
                            type="submit"
                            disabled={loading || !hasChanges}
                            style={{
                                width: "100%",
                                height: "52px",
                                backgroundColor: loading || !hasChanges ? "#d1d5db" : "#ff6b35",
                                border: "none",
                                borderRadius: "12px",
                                color: "#fff",
                                fontWeight: 700,
                                cursor: loading || !hasChanges ? "not-allowed" : "pointer"
                            }}
                        >
                            {loading
                                ? "Modification..."
                                : "Mettre à jour"}
                        </button>

                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                width: "100%",
                                height: "52px",
                                marginTop: "10px",
                                backgroundColor: "#fff",
                                border: "1px solid #e5e7eb",
                                borderRadius: "12px"
                            }}
                        >
                            Annuler
                        </button>
                    </div>

                </form>
            </div>
        </>
    );
};

EditTableModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onFormSubmit: PropTypes.func,
    TableData: PropTypes.shape({
        code_qr: PropTypes.string,
        numero_table: PropTypes.string,
        capacite: PropTypes.number,
        statut: PropTypes.string,
        type_table: PropTypes.number
    })
};

export default EditTableModal;
